import React, { useState, useEffect } from 'react';
import KickImage from 'Reuseables/KickImage';
import Thumbnails from "../PageProductDetails/Detail/Thumbnails";
import { TextRupiah } from "../Text"
import { connect } from "react-redux"
import styled from "styled-components"
import {
  getRaffleGroup,
  getUserRaffleTickets,
  getRafflesToday
} from "../../actions/kafairAction";
import { getCloudImageUrl, emptyImage } from "../../utils";
import FlashSaleImage from "../../images/flashsale.png";
import emptySneakerImg from "../../images/emptysneakers2.png";
import emptyApparelImg from "../../images/emptyapparels.png";
import emptyHandbagImg from "../../images/emptyhandbags.png";
import RightArr from "../../images/fs-arrow-right.png";
import LeftArr from "../../images/fs-arrow-left.png";
import Countdown from "react-countdown";
import Slider from "react-slick";
import moment from "moment";
import { RESOURCE_URL } from "../../config"
import { withRouter, history } from "react-router-dom"

const PreviousArrow = (props) => {
  const { className, style, onClick } = props;
  const LeftArrow = styled.div`
    &::before {
      content: "" !important;
    }
    img {
      margin-left: 5px;
      width: 20px !important;
      height: 20px !important;
      object-fit: contain;
      border-radius: 30px;
    }

    @media (max-width: 480px) {
      img {
        width: 20px !important;
        height: 20px !important;
        position: absolute;
        left: -15px;
      }
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <KickImage src={LeftArr} alt="..." />
    </LeftArrow>
  );
};

const NextArrow = (props) => {
  const { className, style, onClick } = props;
  const LeftArrow = styled.div`
    &::before {
      content: "" !important;
    }
    img {
      width: 20px !important;
      height: 20px !important;
      object-fit: contain;
      border-radius: 30px;
      right: -5px;
      position: absolute;
    }

    @media (max-width: 480px) {
      img {
        right: 20px;
        width: 20px !important;
        height: 20px !important;
        top: -2px;
      }
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <KickImage src={RightArr} alt="..." />
    </LeftArrow>
  );
};

function GreenRaffle({ history, getRaffleGroup, getUserRaffleTickets, dataRaffleGroup, getRafflesToday, dataCategory, userRaffleTicket, raffle, category }) {

  const [raffleProducts, setRaffleProducts] = useState([])
  const [raffleQuery, setRaffleQuery] = useState('')

  useEffect(() => {
    const raffleQuery = dataRaffleGroup.length > 0 && dataRaffleGroup[0].query;

    console.log(category, "ini category")

    getUserRaffleTickets()

    getRaffleGroup()
      .then(({ value }) => {
        if(value.data.data.length > 0 && value.data.data[0].value[0].query) {
          return getRafflesToday(value.data.data[0].value[0].query)
        }
      })
      .then(({ value }) => {
        if(value.data.data){
          setRaffleProducts(value.data.data)
        }
      })
      .catch(e => null)
  }, [])


  function goToPage() {
    const raffleQuery = dataRaffleGroup[0] ? dataRaffleGroup[0].query : "green+raffle"

    history.push(`/${dataCategory}/raffle/${raffleQuery}`)
  }

  const ticketType = dataRaffleGroup.length > 0? dataRaffleGroup[0].ticket_type : "";

  const userTicket =
      userRaffleTicket &&
      userRaffleTicket.data &&
      userRaffleTicket.data[ticketType]
        ? userRaffleTicket.data[ticketType].total
        : 0;

  if(raffleProducts.length <= 0 || category !== 'sneakers') return null

  const settings = {
    arrows: raffleProducts.length > 4,
    // autoplay:true,
    infinite: raffleProducts && raffleProducts.length > 4,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    lazyLoad: true,
    dots: false,
    swipe: false,
    prevArrow: <PreviousArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="green-raffle-section">
      <div className="green-raffle-header">
        <div className="green-raffle-header__left">
          <h3>{dataRaffleGroup.length > 0 && dataRaffleGroup[0] && dataRaffleGroup[0].title}</h3>
          <p>Get tickets from every W.Essentiels x Kick Avenue Transaction</p>
        </div>
        <div style={{ backgroundColor: dataRaffleGroup.length >0 &&  dataRaffleGroup[0] && dataRaffleGroup[0].color }} className="green-raffle-header__right">
          <p>Tickets: <span style={{ fontFamily: "Nunito Bold" }}>{userTicket}</span></p>
        </div>
      </div>
      <div style={raffleProducts.length > 0 && raffleProducts.length <= 4 && {display: "flex", justifyContent: "center", alignItems: "center"}} className="green-raffle__content">
        {
          window.screen.availWidth > 480 && raffleProducts.length > 0 && raffleProducts.length <= 4 ?
          raffleProducts.map(item => {
            return <div key={item.id} className="content-container">
              <div style={{width: "235px", margin: "0 20px"}} className="content-slide">
                <p className="raffle-brand">{item && item.product && item.product.brand && item.product.brand.name}</p>
                <p style={{ fontFamily: "Nunito Bold", height: "30px" }}>{item && item.display_name}</p>
                <KickImage src={item.product_variant_images.length > 0 && new RegExp("\\b" + "s3.amazonaws.com" + "\\b").test(item.product_variant_images[0].URL)
                  ? getCloudImageUrl(
                    item.product_variant_images[0].URL,
                    400
                  )
                  : emptyImage(dataCategory)} alt={item.display_name} />
                <p style={{ marginTop: "30px", textAlign: "center", fontFamily: "Nunito Bold" }}><TextRupiah
                  prefix="IDR. "
                  color="black"
                  align="center"
                  value={item.pivot && item.pivot.retail_price.toString()}
                  bold={true}
                /></p>
              </div>
            </div>
          })
            : 
          <Slider {...settings}>
            {
              raffleProducts.length > 0 && raffleProducts.map(item => {
                return <div key={item.id} className="content-container">
                  <div className="content-slide">
                    <p className="raffle-brand">{item && item.product && item.product.brand && item.product.brand.name}</p>
                    <p style={{ fontFamily: "Nunito Bold", height: "30px" }}>{item && item.display_name}</p>
                    <KickImage src={item.product_variant_images.length > 0 && new RegExp("\\b" + "s3.amazonaws.com" + "\\b").test(item.product_variant_images[0].URL)
                      ? getCloudImageUrl(
                        item.product_variant_images[0].URL,
                        400
                      )
                      : emptyImage(dataCategory)} alt={item.display_name} />
                    <p style={{ marginTop: "20px", textAlign: "center", fontFamily: "Nunito Bold" }}><TextRupiah
                      prefix="IDR. "
                      color="black"
                      align="center"
                      value={item.pivot && item.pivot.retail_price.toString()}
                      bold={true}
                    /></p>
                  </div>
                </div>
              })
            }
          </Slider>
        }
      </div>
      <div className="green-raffle-footer">
        <p onClick={() => goToPage()}>View All</p>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  raffle: state.dataKaFair.raffle,
  dataRaffleGroup: state.dataKaFair.raffleGroup.data,
  dataCategory: state.dataCategory.selected,
  userRaffleTicket: state.dataKaFair.userRaffleTicket
})

const mapDispatchToProps = dispatch => ({
  getUserRaffleTickets: () => dispatch(getUserRaffleTickets()),
  getRaffleGroup: () => dispatch(getRaffleGroup()),
  getRafflesToday: query => dispatch(getRafflesToday(query))
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(GreenRaffle))
